import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4 bg-white">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-background-100 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-background-100 text-foreground-400">
          <i className="ri-emotion-sad-line text-2xl" />
        </div>
        <h1 className="text-xl md:text-2xl font-semibold text-foreground-950 mt-6">页面未找到</h1>
        <p className="mt-3 text-foreground-500 leading-relaxed">
          抱歉，您访问的页面不存在或已被移除
        </p>
        <Link
          to="/"
          className="inline-block mt-6 px-6 py-2.5 text-sm font-medium rounded-full bg-foreground-950 text-white hover:bg-foreground-800 transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}